import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthStore } from "./store/authStore";
import { JobStore } from "./store/jobStore";
import Wordpress from "./Wordpress";
import { SnackbarProvider } from 'notistack';

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    {process.env.REACT_APP_BUILD_TARGET === "wordpress" ? (
      <Wordpress jobStore={JobStore} />
    ) : (
      <SnackbarProvider maxSnack={5}>
        <App authStore={AuthStore} jobStore={JobStore} />
      </SnackbarProvider>
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
